document.addEventListener('DOMContentLoaded', () => {
  pushReview();
  sliderReassurance();
  });

  /**
   * Retrieve the first review from the stamped reviews and display it in the push review gallery
   */
  function pushReview() {
    const observer = new MutationObserver((mutations, obs) => {
      const stampedReviews = document.querySelector('.stamped-reviews');
      if (stampedReviews) {

        // Get the first review with a rating of 5 or 4
        const firstReview = stampedReviews.querySelector('.stamped-review[data-rating="5"]');

        // If there is no review (rating 5 or 4) or no reviews at all, remove the push review gallery
        if (!firstReview || !stampedReviews.children.length) {
          const pushReviewGallery = document.querySelector('.push-review-gallery');
          if (pushReviewGallery) {
            pushReviewGallery.remove();
          }
          return;
        }

        const titleEl = firstReview.querySelector('.stamped-review-header-title');
        const bodyEl = firstReview.querySelector('.stamped-review-content-body');
        const authorEl = firstReview.querySelector('.author');
        const dateEl = firstReview.querySelector('.created');
        const ratingEl = parseInt(firstReview.getAttribute('data-rating'));

        const galleryTitle = document.querySelector('.push-review-gallery__title');
        const galleryDesc = document.querySelector('.push-review-gallery__description');
        const galleryInfos = document.querySelector('.push-review-gallery__infos');
        const galleryStars = document.querySelector('.push-review-gallery__stars');

        if (galleryTitle && titleEl) {
          galleryTitle.textContent = titleEl.textContent.trim();
        }

        if (galleryDesc && bodyEl) {
          galleryDesc.innerHTML = `<p>${bodyEl.textContent.trim()}</p>`;
        }

        if (galleryInfos && authorEl && dateEl) {
          const formattedText = `${authorEl.textContent.trim()} — le ${formatDate(dateEl.textContent.trim())}`;
          galleryInfos.textContent = formattedText;
        }

        if (galleryStars && ratingEl) {
          const rating = parseInt(ratingEl);
          for (let i = 0; i < rating; i++) {
            const starSvg = document.createElement('div');
            starSvg.innerHTML = '<svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11"><path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#1c1c1c"></path></svg>';
            galleryStars.appendChild(starSvg.firstChild);
          }
        }




        obs.disconnect(); // Stop observing
      }
    });

    // Ensure the body is available before observing
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  /**
   * Format the date to be displayed in the push review gallery
   */
  function formatDate(dateStr) {
    const [day, month, year] = dateStr.split('/');
    const months = [
      'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ];
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  }

  function sliderReassurance() {
    const slidersButtons = document.querySelectorAll('.slider__nav > a');

    slidersButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = button.getAttribute('href').replace('#', '');
        const target = document.getElementById(targetId);

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        }
      });
    });
  }


